import { transformLocationHref } from '../conversational-search-logic/utils/utils';
import * as sessionStorageHelpers from '../conversational-search-logic/storage-manager/storage-manager-helpers';
import type { EventEmitter } from '@stencil/core';

export const getQueryParamValue = (param: string) => {
    const urlObject = new URL(window.location.href);

    return urlObject.searchParams.get(param);
};

export const removeQueryParam = (param: string) => {
    const urlObject = new URL(window.location.href);

    urlObject.searchParams.delete(param);
    history.replaceState({}, '', urlObject.toString());
};

export const performOpeningChatActions = (eventEmitter: EventEmitter) => {
    sessionStorageHelpers.setCTAActionSessionStorageValue();
    eventEmitter.emit({ isChatVisible: true });
    sessionStorageHelpers.setExternalOriginSessionStorageValue();
};

export const handleInvocationUrlChanges = () => {
    const invocationUrl =
    sessionStorageHelpers.getExternalOriginInvocationURLSessionStorageValue();

    if (invocationUrl && invocationUrl !== transformLocationHref()) {
      sessionStorageHelpers.removeExternalOriginSessionStorageValue();
      sessionStorageHelpers.removeExternalOriginInvocationURLSessionStorageValue();
    }
};

export const handleExternalOriginParam = async (
  isConversationalSearchActive: boolean,
  callbackEventEmitter: EventEmitter<{
    isChatVisible: boolean;
  }>,
) => {
    if (isConversationalSearchActive) {
      const genAIQueryParam = getQueryParamValue('genai');

      if (genAIQueryParam === 'true') {
        await performOpeningChatActions(callbackEventEmitter);
        await removeQueryParam('genai');
        sessionStorageHelpers.setExternalOriginInvocationURLSessionStorageValue();
      }
    }
};
